import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import channelSlice from './slices/channelSlice';
import commentTypeSlice from './slices/commentTypeSlice';
import commmonSlice from './slices/commonSlice';
import consumerAdressSlice from './slices/consumerAddressSlice';
import GeneralReportSlice from './slices/generalReportSlice';
import consumerPhoneSlice from './slices/consumerPhoneTypeSlice';
import placeSlice from './slices/placeSlice';
import paymentSlice from './slices/paymentSlice';
import paymentTypeSlice from './slices/paymentTypeSlice';
import consumerTypeSlice from './slices/consumerTypeSlice';
import taskTypeSlice from './slices/taskTypeSlice';
import pdfRuleForPriceFieldsSlice from './slices/pdfRuleForPriceFieldsSlice';
import statusSlice from './slices/statusSlice';
import warrantySlice from './slices/warrantyTypeSlice';
import warrantyTimeSlice from './slices/warrantyTimeExceptionSlice';
import priceOperationSlice from './slices/priceOperationSlice';
import userSlice from './slices/userSlice';
import workOrderDetailSlice from './slices/workOrderDetailSlice';
import jobControlSlice from './slices/jobControlSlice';
import workOrderHistorySlice from './slices/workOrderHistorySlice';
import productHistorySlice from './slices/productHistorySlice';
import serviceShopSlice from './slices/serviceShopSlice';
import productSkuSlice from './slices/productAlternativeSlice';
import flsSlice from './slices/flsSlice';
import dashboardSlice from './slices/dashboardSlice';
import addressSlice from './slices/addressSlice';
import employeeSlice from './slices/employeeSlice';
import issueSlice from './slices/issueSlice';
import productExchangeSlice from './slices/productExchangeSlice';
import WaitingForDiscountApprovelSlice from './slices/WaitingForDiscountApprovelSlice';
import StatusManagementSlice from './slices/StatusManagementSlice';
import NotificationCenterInternalNotificationSlice from './slices/NotificationCenterInternalNotificationSlice';
import exchangeReasonSlice from './slices/exchangeReasonSlice';
import userTypesSlice from './slices/userTypesSlice';
import defectSlice from './slices/defectSlice';
import labourSlice from './slices/labourSlice';
import supportInfoSlice from './slices/supportInfoSlice';
import accountingSlice from './slices/accountingSlice';
import SmsEmailTemplateSlice from './slices/Toinfo';
import NotificationCenterTemplateSlice from './slices/NotificationCenterTemplateSlice';
import brandSlice from './slices/brandSlice';
import rejectReasonSlice from './slices/rejectReasonSlice';
import cancellationReasonSlice from './slices/cancellationReasonSlice';
import vulnerabilitySlice from './slices/vulnerabilitySlice';
import retailerSlice from './slices/retailerSlice';
import plantsSlice from './slices/plantsSlice';
import exchangeStatusSlice from './slices/exchangeStatusSlice';
import userAuthoritySlice from './slices/userAuthoritySlice';
import priceGroupSlice from './slices/priceGroupSlice';
import productLabourRelationSlice from './slices/productLabourRelationSlice';
import announcementSlice from './slices/announcementSlice';
import adhocquerySlice from './slices/adhocquerySlice';
import serviceShopMaterialSlice from './slices/serviceShopMaterialSlice';
import serviceCapacitySlice from './slices/serviceCapacitySlice';
import paymentgroupSlice from './slices/paymentgroupSlice';
import customerTitleSlice from './slices/customerTitleSlice';
import priorityTypeSlice from './slices/priorityTypeSlice';
import smsReportSlice from './slices/smsReportSlice';
import verificationRulesSlice from './slices/verificationRulesSlice';
import VerificationExecuteSlice from './slices/VerificationExecuteSlice';
import surveyQuestionAnswerSlice from './slices/surveyQuestionAnswerSlice';
import labourOperationSlice from './slices/labourOperationSlice';
import reworkStatuSlice from './slices/reworkStatuSlice';
import statusUpdaterSlice from './slices/statusUpdaterSlice';
import exchangeReasonDetailsSlice from './slices/exchangeReasonDetailsSlice';
import technicalSupportSlice from './slices/technicalsupportSlice';
import technicalKnowledgeBasedSlice from './slices/technicalKnowledgeBasedSlice';
import materialServiceShopSlice from './slices/materialServiceShopSlice';
import productLaunchSlice from './slices/productLaunchSlice';
import technologyTypeSlice from './slices/technologyTypeSlice';
import dynamicGroupSlice from './slices/dynamicGroupSlice';
import sparePartOrderManagementSlice from './slices/sparePartOrderManagementSlice';
import revenuePricesSlice from './slices/revenuePricesSlice';
import interventionControlSlice from './slices/interventionControlSlice'
import noRevenueDefectsSlice from './slices/noRevenueDefectsSlice';
import serialNumberSlice from './slices/serialNumberSlice';
import retailerDiscountSlice from './slices/RetailerDiscountSlice';
import storageLocationSlice from './slices/StorageLocationSlice';
import translationSlice from './slices/translationSlice';
import generalSlice from './slices/generalSlice';
import externalClaimSlice from './slices/externalClaimSlice';
import schedulingSlice from './slices/schedulingSlice';
import manualDiscountSlice from './slices/manualDiscountSlice';
import pakistanManualDiscountSlice from './slices/pakistanManualDiscountSlice';
import accountingFinalOperationsSlice from './slices/accountingFinalOperationsSlice';
import portalReportSlice from './slices/portalReportSlice';
import rejectByHqSlice from './slices/rejectByHqSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['rejectByHq']
};
const reducers = combineReducers({
  address: addressSlice.reducer,
  channel: channelSlice.reducer,
  commentType: commentTypeSlice.reducer,
  common: commmonSlice.reducer,
  consumerAdress: consumerAdressSlice.reducer,
  generalReport: GeneralReportSlice.reducer,
  consumerPhone: consumerPhoneSlice.reducer,
  consumerType: consumerTypeSlice.reducer,
  paymentType: paymentTypeSlice.reducer,
  taskType: taskTypeSlice.reducer,
  pdfRuleForPriceFields: pdfRuleForPriceFieldsSlice.reducer,
  status: statusSlice.reducer,
  user: userSlice.reducer,
  place: placeSlice.reducer,
  payment: paymentSlice.reducer,
  warranty: warrantySlice.reducer,
  workOrderDetail: workOrderDetailSlice.reducer,
  jobControl: jobControlSlice.reducer,
  workOrderHistory: workOrderHistorySlice.reducer,
  productHistory: productHistorySlice.reducer,
  serviceShop: serviceShopSlice.reducer,
  productSku: productSkuSlice.reducer,
  fls: flsSlice.reducer,
  dashboard: dashboardSlice.reducer,
  employee: employeeSlice.reducer,
  issue: issueSlice.reducer,
  brand: brandSlice.reducer,
  labour: labourSlice.reducer,
  productExchange: productExchangeSlice.reducer,
  WaitingForDiscountApprovel: WaitingForDiscountApprovelSlice.reducer,
  StatusManagement: StatusManagementSlice.reducer,
  NotificationCenterInternalNotificationSlice: NotificationCenterInternalNotificationSlice.reducer,
  rejectReason: rejectReasonSlice.reducer,
  cancellationReason: cancellationReasonSlice.reducer,
  reworkStatu: reworkStatuSlice.reducer,
  userTypes: userTypesSlice.reducer,
  exchangeReason: exchangeReasonSlice.reducer,
  exchangeReasonDetails: exchangeReasonDetailsSlice.reducer,
  vulnerabilities: vulnerabilitySlice.reducer,
  retailer: retailerSlice.reducer,
  plants: plantsSlice.reducer,
  exchangeStatus: exchangeStatusSlice.reducer,
  defect: defectSlice.reducer,
  supportInfo: supportInfoSlice.reducer,
  accounting: accountingSlice.reducer,
  SmsEmailTemplate: SmsEmailTemplateSlice.reducer,
  NotificationCenterTemplateSlice: NotificationCenterTemplateSlice.reducer,
  userAuthority: userAuthoritySlice.reducer,
  priceGroup: priceGroupSlice.reducer,
  priorityType: priorityTypeSlice.reducer,
  productLabourRelation: productLabourRelationSlice.reducer,
  announcement: announcementSlice.reducer,
  technicalsupport: technicalSupportSlice.reducer,
  adhocquery: adhocquerySlice.reducer,
  serviceShopMaterial: serviceShopMaterialSlice.reducer,
  serviceCapacity: serviceCapacitySlice.reducer,
  paymentgroup: paymentgroupSlice.reducer,
  customerTitles: customerTitleSlice.reducer,
  smsReport: smsReportSlice.reducer,
  warrantyTime: warrantyTimeSlice.reducer,
  verificationRules: verificationRulesSlice.reducer,
  VerificationExecute: VerificationExecuteSlice.reducer,
  surveyQuestionAnswer: surveyQuestionAnswerSlice.reducer,
  priceOperation: priceOperationSlice.reducer,
  labourOperation: labourOperationSlice.reducer,
  technicalKnowledgeBased: technicalKnowledgeBasedSlice.reducer,
  materialServiceShop: materialServiceShopSlice.reducer,
  productLaunch: productLaunchSlice.reducer,
  technologyType: technologyTypeSlice.reducer,
  statusUpdateMethod: statusUpdaterSlice.reducer,
  dynamicGroup: dynamicGroupSlice.reducer,
  sparePartOrderManagement: sparePartOrderManagementSlice.reducer,
  revenuePrices: revenuePricesSlice.reducer,
  interventionControl: interventionControlSlice.reducer,
  noRevenueDefects: noRevenueDefectsSlice.reducer,
  serialNumber: serialNumberSlice.reducer,
  retailerDiscount: retailerDiscountSlice.reducer,
  storageLocation: storageLocationSlice.reducer,
  translation: translationSlice.reducer,
  general: generalSlice,
  externalClaims: externalClaimSlice,
  scheduling: schedulingSlice.reducer,
  manualDiscount: manualDiscountSlice.reducer,
  pakistanManualDiscount: pakistanManualDiscountSlice.reducer,
  accountingFinalOperations: accountingFinalOperationsSlice.reducer,
  portalReport: portalReportSlice.reducer,
  rejectByHq: rejectByHqSlice.reducer
});

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
});

export default store;
